import * as glob$file0 from '/vercel/path0/src/view/contact.svelte';
import * as glob$file1 from '/vercel/path0/src/view/index.svelte';
import * as glob$file2 from '/vercel/path0/src/view/blog/index.svelte';
import * as glob$file3 from '/vercel/path0/src/view/blog/search.svelte';
import * as glob$file4 from '/vercel/path0/src/view/home.svelte';
import * as glob$file5 from '/vercel/path0/src/view/blog/subscribe.svelte';
import * as glob$file6 from '/vercel/path0/src/view/blog/post.svelte';


export default [
	glob$file0,
	glob$file1,
	glob$file2,
	glob$file3,
	glob$file4,
	glob$file5,
	glob$file6,
];